import styled from "@emotion/styled";

export const FiltrosContainer = styled.div`
    display: flex;
    gap: 1rem;
    align-items: center;
    flex-wrap: wrap;
    width: 100%;
`;

